import { LessonTitleContentExtension } from "@tiptap-content/extensions/lesson-title/lesson-title-content-extension"
import { ReactNodeViewRenderer } from "@tiptap/react"
import { cancelBackspaceAtNodeStart } from "../../util/cancel-backspace-at-node-start"
import { splitLessonTitle } from "../../util/split-lesson-title"
import { LessonTitleComponent } from "./lesson-title-component"

export const ExtensionLessonTitle = LessonTitleContentExtension.extend({
  addKeyboardShortcuts() {
    return {
      Enter: () => splitLessonTitle(this.editor, this.name),
      "Shift+Enter": () => splitLessonTitle(this.editor, this.name),
      Backspace: () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Shift-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Mod-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
      "Alt-Backspace": () => cancelBackspaceAtNodeStart(this.editor, this.name),
    }
  },

  addNodeView() {
    return ReactNodeViewRenderer(LessonTitleComponent)
  },
})
